export const NEW_ITEM_ACTION = {
  ADD: "ADD",
  EDIT: "EDIT",
};

export const NEW_ITEM_ACTION_MAP = new Map([
  [NEW_ITEM_ACTION.ADD, "إضافة"],
  [NEW_ITEM_ACTION.EDIT, "تعديل"],
]);
